import React, { useEffect } from 'react';

interface ModalOverlayProps {
  children: React.ReactNode;
  /** "dialog" for forms, "alertdialog" for confirmations */
  role?: 'dialog' | 'alertdialog';
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  /** Ref forwarded to the overlay container (for focus trap) */
  innerRef?: React.Ref<HTMLDivElement>;
}

const ModalOverlay: React.FC<ModalOverlayProps> = ({
  children,
  role = 'dialog',
  ariaLabelledBy,
  ariaDescribedBy,
  onKeyDown,
  innerRef,
}) => {
  // Solange der Dialog offen ist, darf die Seite dahinter nicht scrollen - sonst
  // schiebt das Mausrad den Hintergrund weg statt den Dialoginhalt.
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = previous; };
  }, []);

  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto overscroll-contain animate-fade-in"
      style={{ background: 'var(--overlay-bg)' }}
      role={role}
      aria-modal="true"
      aria-labelledby={ariaLabelledBy}
      aria-describedby={ariaDescribedBy}
      onKeyDown={onKeyDown}
      ref={innerRef}
    >
      {/* min-h-full + my-auto: kurze Dialoge bleiben zentriert, hohe beginnen oben
          und lassen sich vollstaendig scrollen, statt oben aus dem Bild zu laufen. */}
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="animate-modal-in my-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalOverlay;
